import angular from 'angular';
import { NavigationDirectiveModule } from './navigation/navigation.directive';
import { OrdersServiceModule } from '@b2c/common/services/order/order.service';
import { AnalyticsServiceModule } from '@b2c/common/services/analytics/analytics.service';
import { AuthServiceModule } from '@b2c/common/services/auth/auth.service';
import { CartServiceModule } from '@b2c/common/services/cart/cart.service';
import { MembershipServiceModule } from '@b2c/common/services/membership/membership.service';
import { QueryStringBuilderFactoryModule } from '@b2c/common/factories/QueryStringBuilder/QueryStringBuilder.factory';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';

export const HeaderDirectiveModule = angular
  .module('acme.common.directive.header', [
    QueryStringBuilderFactoryModule,
    AuthServiceModule,
    MembershipServiceModule,
    OrdersServiceModule,
    CartServiceModule,
    ThemesServiceModule,
    AnalyticsServiceModule,
    HelpersServiceModule,
    NavigationDirectiveModule,
  ])
  .directive('header', function () {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/header/header.tpl.html',
      scope: {
        showNavigation: '@',
        disableLinks: '@',
      },

      link: function ($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: HeaderController,
    };
  }).name;

HeaderController.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$document',
  'AuthService',
  'MembershipService',
  'CartService',
  'OrderService',
  'ThemesService',
  'AnalyticsService',
  'HelpersService',
];

function HeaderController(
  $rootScope,
  $scope,
  $state,
  $document,
  AuthService,
  MembershipService,
  CartService,
  OrderService,
  ThemesService,
  AnalyticsService,
  HelpersService
) {
  $scope.header = {
    cartItems: 0,
    isLoggedIn: false,
    logoText: false,
    companyPhone: false,
    isMobile: false,
    tenantHasMembership: false,
    tenantHasMembershipSales: false,
    membershipLinkText: '',
    hideLogin: false,

    init: function () {
      this.isMobile = window.CONFIG.mobile;
      this.cartItems = CartService.getItemCount();
      var logo = ThemesService.getLogo(),
        companyPhone = ThemesService.getCompany('phoneNumber'),
        tenantHasMembership = ThemesService.getCompany('membership'),
        tenantHasMembershipSales = ThemesService.getCompany('membershipSales');

      this.hideLogin = this.getLoginSetting();

      if (logo) {
        this.logoText = logo.label;
      }

      if (companyPhone) {
        this.companyPhone = companyPhone;
      }

      $scope.$on('Header::UpdateCartItems', this.onUpdateCartItems);
      $scope.$on('$destroy', this.onDestroy);

      if (!MembershipService.checkVerifiedMembership($state.params.tenantId)) {
        MembershipService.killCookie();
      }
      if (tenantHasMembershipSales) {
        this.tenantHasMembershipSales = tenantHasMembershipSales;
      }
      if (tenantHasMembership) {
        this.tenantHasMembership = tenantHasMembership;
        this.getMembershipLabels();
      }

      $rootScope.$on('Membership::reinitializedAfterChangeFromAnotherTab', () => {
        if (ThemesService.getCompany('membership')) {
          $scope.header.tenantHasMembership = tenantHasMembership;
          $scope.header.getMembershipLabels();
          $scope.$apply();
        }
      });
    },

    getLoginSetting: function () {
      var setting = ThemesService.getTextVariable('header-hide-login', false);
      return setting === true || setting === 'true';
    },

    checkMembership: function () {
      var r = false;

      MembershipService.getCookie();

      if (MembershipService.cookie) {
        if ($state.params.tenantId === MembershipService.cookie.tenantId) {
          r = true;
        }
      }

      return r;
    },

    getMembershipLabels: function () {
      var name = '',
        member;

      if (MembershipService.checkVerifiedMembership($state.params.tenantId)) {
        member = MembershipService.getVerifiedMember() || MembershipService.getPrimaryMember();

        if (member) {
          name = MembershipService.getMemberName(member);
        }

        this.membershipLinkText = 'Member: ' + name;
      } else {
        this.membershipLinkText = 'My Membership';
      }
    },

    getLogin: function () {
      var r = 'My orders';

      AuthService.getCookie();

      if (AuthService.cookie) {
        this.isLoggedIn = true;
        r = 'Orders: ' + AuthService.cookie.email;
      }

      return r;
    },

    getCartSummary: function () {
      var count = Math.abs(parseInt(this.cartItems, 10)),
        summary = '';

      if (count === 1) {
        summary = this.cartItems + ' item';
      } else if (count > 1) {
        summary = this.cartItems + ' items';
      }
      return summary;
    },

    toggleNavigation: function (e) {
      $scope.$emit('App::ToggleNavigation', { event: e });
    },

    showNavigation: function () {
      $scope.$emit('App::ShowNavigation');
    },

    hideNavigation: function () {
      $scope.$emit('App::HideNavigation');
    },

    launchLogin: function () {
      $rootScope.$emit('Header::LaunchLogin');

      if (this.isLoggedIn) {
        AnalyticsService.event({
          name: 'Login',
          category: 'Header',
          label: 'Authenticated',
        });

        var accountUrl = HelpersService.makeUrl(['/account', $state.params.tenantId, 'orders']);
        HelpersService.setHref(accountUrl);
      } else if (window.location.pathname.match(/^\/auth/)) {
        AnalyticsService.event({
          name: 'Login',
          category: 'Header',
          label: 'Direct',
        });

        var authUrl = HelpersService.makeUrl(['/auth', $state.params.tenantId, 'login']);
        HelpersService.setHref(authUrl);
      } else {
        AnalyticsService.event({
          name: 'Login',
          category: 'Header',
          label: 'Tokenized',
        });

        var currentQueryParams = HelpersService.parseQueryParams(window.location.href);
        var ref = HelpersService.makeUrl([window.location.pathname], currentQueryParams);
        var authUrlWithRef = HelpersService.makeUrl(['/auth', $state.params.tenantId, 'login'], { ref: ref });
        HelpersService.setHref(authUrlWithRef);
      }
    },

    launchLogout: function () {
      this.isLoggedIn = AuthService.logout() ? false : true;
      if (!this.isLoggedIn) {
        AnalyticsService.event({
          name: 'Logout',
          category: 'Header',
          label: 'Direct',
        });

        var url = HelpersService.makeUrl(['/events', $state.params.tenantId, 'list']);
        HelpersService.setHref(url);
      }
    },

    launchOrders: function () {
      if ($scope.disableLinks) {
        return;
      }

      $rootScope.$emit('Header::LaunchOrders');

      AnalyticsService.event({
        name: 'Orders::Tickets',
        category: 'Header',
        label: 'Cart Link',
      });

      var queryParams = {
        eventId: $state.params.eventId,
        comboId: $state.params.comboId,
        eventIds: $state.params.eventIds,
        membershipId: $state.params.membershipId,
        date: $state.params.date || OrderService.getDate(),
        cart: true,
      };
      var url = HelpersService.makeUrl(['/orders', $state.params.tenantId, 'tickets'], queryParams);
      HelpersService.setHref(url);
    },

    launchMemberVerify: function () {
      $rootScope.$emit('Header::LaunchMemberVerify');

      var metadata = MembershipService.getMemberVerifyEventMetadata($state.params);

      AnalyticsService.event(metadata.event);
      HelpersService.setHref(metadata.href);
    },

    launchHome: function () {
      $rootScope.$emit('Header::LaunchHome');

      if ($scope.disableLinks) {
        return;
      }

      var logo = ThemesService.getLogo();
      var logoLink = logo ? logo.link : '';

      if (logoLink === '#') {
        var queryParams = {
          eventId: $state.params.eventId,
          date: $state.params.date || OrderService.getDate(),
        };
        var url = HelpersService.makeUrl(['/events', $state.params.tenantId, 'list'], queryParams);
        HelpersService.setHref(url);
      } else {
        HelpersService.setHref(logoLink + HelpersService.addDonationParams());
      }
    },

    onUpdateCartItems: function (e, data) {
      $scope.header.cartItems = data.count;
    },

    onDestroy: function (e, data) {
      $document.unbind('touchmove');
    },
  };

  $scope.header.init();
}
